const Emitter = require('mn-utils/Emitter');
const delay = require('mn-utils/delay');


module.exports = (open$, back) => {
  back && open$.getValue() && back();
  const options$ = new Emitter();
  return [
    Emitter.combine([
      open$,
      options$,
    ]).map((v) => {
      const options = v[1];
      return v[0] && options ? options : 0;
    }),
    (options) => {
      options$.emit(options || {});
      delay(open$.emit, 50, [1]);
    },
  ];
};
